import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Like } from '@modules/common/types/like';
import { Project } from '@modules/tasks/types/project';
import { Task } from '@modules/tasks/types/task';
import { TasksFilters } from '@modules/tasks/types/tasks-filters';
import { BoardService } from '@modules/tasks/services/board.service';

@Component({
  selector: 'app-project-tasks-list',
  templateUrl: './project-tasks-list.component.html',
  // Unsaved, it fills the tab as the board does, so its "No tasks" sits where the board's did instead of jumping
  // to the top when the view switches (Johanna, 2026-10-21).
  host: {
    '[class.block]': '!!projectId()',
    '[class.flex-1]': '!projectId()',
    '[class.flex]': '!projectId()',
    '[class.flex-col]': '!projectId()',
  },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectTasksListComponent {
  public readonly project = input<Project>();
  /**
   * Saving a brand-new project mutates the same `project` object in place (see
   * `FullFormBaseComponent.applyUpdatedItem`) rather than replacing the reference — an OnPush signal
   * input only re-checks when its new value differs by `Object.is`, so `[project]="project()"` alone
   * never notices the id arriving and the "Save your project..." placeholder would stay stuck. A
   * separate primitive id input DOES change by value, so the empty-state check below reads this
   * instead of `project()?.id`.
   */
  public readonly projectId = input<string>();
  public readonly filters = input<Like<TasksFilters>>({});

  public readonly clickTask = output<Task>();
  public readonly openTask = output<Task>();
  public readonly doubleClickTask = output<Task>();
  public readonly openSubtask = output<Task>();

  private readonly boardService = inject(BoardService);

  protected readonly sections = toSignal(this.boardService.getSections(), { initialValue: [] });

  protected addSection(): void {
    this.boardService.addSection();
  }
}
